export enum PageOrientation {
    Portrait = "Portrait",
    Landscape = "Landscape"
}